import React from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import PrecisionWater from './components/PrecisionWater';
import CostReduction from './components/CostReduction';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navigation />
      <Hero />
      <Features />
      <HowItWorks />
      <PrecisionWater />
      <CostReduction />
      <Testimonials />
      <CTA />
      <Footer />
    </div>
  );
}

export default App;
